import { AuthProvider } from "./AuthContext";
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  split,
} from "@apollo/client";
import {
  removeTypenameFromVariables,
  KEEP,
} from "@apollo/client/link/remove-typename";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
//import { createUploadLink } from "apollo-upload-client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
// import { GET_SITE_SETTINGS } from "./queries";
// import { SiteSettingsProvider } from "./SiteSettingsContext";

import { getMainDefinition } from "@apollo/client/utilities";
import { setContext } from "@apollo/client/link/context";
import Router from "./Router";
import { Toaster } from "sonner";
import { ConfirmationProvider } from "./context/ConfirmationContext";
import { DemoModeProvider } from "./context/DemoModeContext";
import { UnsavedChangesProvider } from "./context/UnsavedChangesContext";

const GRAPHQL_ENDPOINT =
  process.env.REACT_APP_API_URL ?? "http://localhost:4000/graphql";
const GRAPHQL_ENDPOINT_WS =
  process.env.REACT_APP_API_URL_WS ?? "ws://localhost:4000/graphql";

const wsLink = new GraphQLWsLink(
  createClient({
    url: GRAPHQL_ENDPOINT_WS,
    connectionParams: {
      //authToken: user.authToken,
      reconnect: true,
    },
  })
);

const httpLinkOrigin = createUploadLink({
  uri: GRAPHQL_ENDPOINT,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("furnisystems-token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const httpLink = authLink.concat(httpLinkOrigin);

// const httpLink = new HttpLink({
//   uri: GRAPHQL_ENDPOINT,
// });

// The split function takes three parameters:
//
// * A function that's called for each operation to execute
// * The Link to use for an operation if the function returns a "truthy" value
// * The Link to use for an operation if the function returns a "falsy" value

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    // console.log(definition)
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

// Strips `__typename` from every outgoing mutation/query variable before it
// hits the wire. Apollo's cache stamps `__typename` onto every object it
// hands back from a query result — harmless to read, but fatal to feed
// straight back in as a variable: input types like
// `ProductContainerWhereUniqueInput` only declare `{ id }`, so the extra key
// fails GraphQL's input coercion ("Field \"__typename\" is not defined by
// type ..."). This is a recurring footgun across containers (any
// duplicate/reassign/"seed form from query result" flow is at risk), so it's
// handled once here instead of per call site.
//
// `except: { Json: KEEP }` exempts variables declared as the `Json` scalar
// (e.g. content blocks' `$config`/`$extra_css`) — those are opaque JSON
// blobs, not structured GraphQL input objects, so stripping into them isn't
// needed for coercion and would risk mutating persisted JSON shape. The
// exemption is keyed on the TOP-LEVEL variable's declared type, so it only
// covers variables declared as `$foo: Json` directly — a `Json`-typed field
// nested inside some other structured input variable would still be walked
// and stripped. No mutation in this app currently nests `Json` that way; if
// one ever does, it'll need its own `except` entry. Every top-level variable
// NOT declared as `Json` (all *WhereUniqueInput / *Input types) still gets
// fully stripped, recursively.
const removeTypenameLink = removeTypenameFromVariables({
  except: {
    Json: KEEP,
  },
});

export const client = new ApolloClient({
  link: removeTypenameLink.concat(splitLink),
  cache: new InMemoryCache(),
  // uri: GRAPHQL_ENDPOINT,
  // link: createUploadLink({
  //   url: GRAPHQL_ENDPOINT,
  // }), // We do need this to handle upload streams.
});

function App() {
  return (
    <div>
      <ApolloProvider client={client as any}>
        <AuthProvider>
          <DemoModeProvider>
            <ConfirmationProvider>
              <UnsavedChangesProvider>
                <Router />
              </UnsavedChangesProvider>
            </ConfirmationProvider>
          </DemoModeProvider>
        </AuthProvider>
      </ApolloProvider>
      <Toaster position="bottom-left" richColors expand />
    </div>
  );
}

export default App;
